// Shared synchronous Fluent rendering for browser effects and publication tools.
import {FluentBundle,FluentResource} from '@fluent/bundle';
export const resource=text=>new FluentResource(text);
export function variables(pattern){
  const names=new Set();
  function visit(node){
    if(!node||typeof node!=='object')return;
    if(node.type==='var')names.add(node.name);
    if(node.type==='VariableReference')names.add(node.id.name);
    for(const [key,child]of Object.entries(node))if(key!=='span'){if(Array.isArray(child))child.forEach(visit);else if(child&&typeof child==='object')visit(child);}
  }
  visit(pattern);return [...names].sort();
}
export function bundle(locale,text){
  const result=new FluentBundle(locale,{useIsolating:false});
  const errors=result.addResource(resource(text));if(errors.length)throw errors[0];
  return result;
}
export function localizer(locale,text,fallback){
  const primary=bundle(locale,text),backup=bundle('en',fallback);
  return (id,args)=>{
    for(const source of [primary,backup]){
      const message=source.getMessage(id);if(!message?.value)continue;
      const errors=[],value=source.formatPattern(message.value,args,errors);
      if(!errors.length)return value;
    }
    return id;
  };
}
